import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ContactUsModal } from '../sideMenu/contactUs/ContactUsModal';
import { CONTACT_US_STEPS } from '../sideMenu/contactUs/contactUs.constants';
import { usePetDemosSteps } from './hooks/usePetDemosSteps';
import { PET_DEMOS_STEPS } from './petDemographics.constants';

import styles from './ContactUsFooter.module.css';

const ContactUsFooter = () => {
  const { t } = useTranslation('petDemos');
  const { currentStep } = usePetDemosSteps();

  const [isOpen, setIsOpen] = useState(false);

  function handleCloseModal() {
    setIsOpen(false);
  }

  function handleOpenModal() {
    setIsOpen(true);
  }

  if (currentStep === PET_DEMOS_STEPS.SUBMIT_FAILURE) {
    return null;
  }

  return (
    <>
      <footer className={styles.container}>
        <span className={styles.questions}>
          {t('footer.haveQuestion')}
        </span>

        <button
          className={styles.contactButton}
          onClick={handleOpenModal}
          type="button"
        >
          {t('footer.contactUs')}
        </button>
      </footer>

      <ContactUsModal
        companyStep={CONTACT_US_STEPS.PPI_ONE_PACK}
        onClose={handleCloseModal}
        show={isOpen}
      />
    </>
  );
};

export { ContactUsFooter };
